import { IonText } from '@ionic/react';
import React from 'react';

export default function SectionTitle({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <IonText className={`text-lg font-semibold ${className || ''}`}>{children}</IonText>
  );
};
